/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Geometry } from './Geometry';
import {
    GeometryFromJSON,
    GeometryFromJSONTyped,
    GeometryToJSON,
} from './Geometry';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface Source
 */
export interface Source {
    /**
     * Use this to override the draught of the ship [m] for the route calculation. Deprecated, use ship.draught instead
     * @type {number}
     * @memberof Source
     */
    draught?: number;
    /**
     * 
     * @type {Port}
     * @memberof Source
     */
    port?: Port;
    /**
     * 
     * @type {Ship}
     * @memberof Source
     */
    ship?: Ship;
    /**
     * 
     * @type {Geometry}
     * @memberof Source
     */
    position?: Geometry;
}

/**
 * Check if a given object implements the Source interface.
 */
export function instanceOfSource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SourceFromJSON(json: any): Source {
    return SourceFromJSONTyped(json, false);
}

export function SourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Source {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'draught': !exists(json, 'draught') ? undefined : json['draught'],
        'port': !exists(json, 'port') ? undefined : PortFromJSON(json['port']),
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
        'position': !exists(json, 'position') ? undefined : GeometryFromJSON(json['position']),
    };
}

export function SourceToJSON(value?: Source | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'draught': value.draught,
        'port': PortToJSON(value.port),
        'ship': ShipToJSON(value.ship),
        'position': GeometryToJSON(value.position),
    };
}

